import translations from './magnesium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/magnesium'

export const magnesium: Metal = {
  id: 13,
  slug: 'magnesium',
  name: t.name,
  symbol: 'Mg',
  mines: [
    {
      name: 'Fugu region (China, Shaanxi — 50+ small producers)',
      region: 'Fugu region',
      coordinates: [111.07, 39.03],
    },
    {
      name: 'Nanjing Yunhai & Shanxi Wenxi Yinguang (China)',
      region: 'Nanjing Yunhai & Shanxi Wenxi Yinguang',
      coordinates: [111.18, 35.41],
    },
    {
      name: 'Dead Sea Magnesium (Israel)',
      region: 'Dead Sea Magnesium',
      coordinates: [35.38, 31.07],
    },
  ],
  countries: [
    { name: 'China', percent: 91 },
    { name: 'Brazil', percent: 2 },
    { name: 'Israel', percent: 2 },
    { name: 'Kazakhstan', percent: 2 },
    { name: 'Russia', percent: 1.5 },
    { name: 'Turkey', percent: 1.5 },
  ],
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 2, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
